import { combineReducers } from '@reduxjs/toolkit';

import applicationReducer from './application/application';
import loginReducer from './auth/login';
import registrationReducer from './auth/registration';
import logoutReducer from './auth/logout';
import pathProfileReducer from './profile/patchProfile';
import getMyProfileReducer from './profile/getMyProfile';
import getRolesReducer from './roles/getRoles';
import getPermissionsReducer from './permissions/getPermissions';
import postRolesReducer from './roles/postRoles';
import getRoleDetailsReducer from './roles/getRoleDetails';
import getUsersReducer from './users/getUsers';
import getUserDetailsReducer from './users/getUserDetails';
import patchUserRoleReducer from './users/patchUserRole';
import deleteRolesReducer from './roles/deleteRole';
import getLogsReducer from './logs/getLogs';
import logsFilterReducer from './logs/logsFilter';
import getOrderedPartsReducer from './coilovers/orderedParts/getOrderedParts';
import orderedPartsFilterReducer from './coilovers/orderedParts/orderedPartsFilter';
import patchOrderedPartsReducer from './coilovers/orderedParts/patchOrderedParts';
import deleteOrderedPartsReducer from './coilovers/orderedParts/deleteOrderedParts';
import getWarehouseReducer from './coilovers/warehouse/getWarehouse';
import warehouseFilterReducer from './coilovers/warehouse/warehouseFilter';
import postOrderedPartsReducer from './coilovers/orderedParts/postOrderedParts';
import patchWarehouseReducer from './coilovers/warehouse/patchWarehouse';
import postWarehouseReducer from './coilovers/warehouse/postWarehouse';
import deleteWarehouseReducer from './coilovers/warehouse/deleteWarehouse';
import coOrdersFilterReducer from './coilovers/orders/coOrdersFilter';
import getCoOrdersReducer from './coilovers/orders/getCoOrders';
import deleteCoOrderReducer from './coilovers/orders/deleteCoOrder';
import patchCoOrderReducer from './coilovers/orders/patchCoOrder';
import actionCoOrderReducer from './coilovers/orders/actionCoOrder';
import getNextIncrementValueReducer from './general/getNextIncrementValue';
import getArticlesReducer from './articles/getArticles';
import articlesFilterReducer from './articles/articlesFilter';
import patchArticlesReducer from './articles/patchArticles';
import getArticlesThemeReducer from './articles/getArticlesTheme';
import postArticlesThemeReducer from './articles/postArticlesTheme';
import getBrandListReducer from './general/getBrandList';
import getCarMakeListReducer from './general/getCarMakeList';
import getCarModelListReducer from './general/getCarModelList';
import getCarYearListReducer from './general/getCarYearList';
import getEbayCategoryListReducer from './general/getEbayCategoryList';
import getArticlesDetailsReducer from './articles/getArticlesDetails';
import postArticlesReducer from './articles/postArticles';
import createPartTypeModalReducer from './createPartTypeModal/createPartTypeModal';
import getOrderedPartsListReducer from './general/getOrderedPartsList';
import postOrderedPartsTypeReducer from './general/postOrderedPartsType';
import getWarehouseExistReducer from './general/getWarehouseExist';
import downloadFileReducer from './general/downloadFile';
import getUploadsListReducer from './users/getUploadsList';
import forgotPasswordReducer from './auth/forgotPassword';
import resetPasswordReducer from './auth/resetPassword';
import getListingCompatibilityListReducer from './compatibility/getListingCompatibilityList';
import getCompatibilityModelGroupReducer from './compatibility/getCompatibilityModelGroup';
import getCompatibilityYearGroupReducer from './compatibility/getCompatibilityYearGroup';
import getCompatibilityCarsGroupReducer from './compatibility/getCompatibilityCarsGroup';
import vehicleCompatibilityListReducer from './vehicleCompatibility/vehicleCompatibilityList';
import listingsFilterReducer from './listings/listingsFilter';
import getListingsReducer from './listings/getListings';
import getWarehouseMpnInfoReducer from './coilovers/warehouse/getWarehouseMpnInfo';
import getAcceptanceToDayReducer from './coilovers/acceptance/getAcceptanceToDay';
import getAcceptanceDelaysReducer from './coilovers/acceptance/getAcceptanceDelays';
import postPrintZebraFileReducer from './zebraPrinter/printZebraFile';
import getOrderDoneByListReducer from './general/getOrderDoneByList';
import getAcceptanceIssuesReducer from './coilovers/acceptance/getAcceptanceIssues';
import getOrderStatisticReducer from './statistic/getOrderStatistic';
import getCalculateReportReducer from './calculateRaport/getCalculateReport';
import createNewOrderReducer from './coilovers/orders/createNewOrder';
import getCountriesListReducer from './general/getCountriesList';
import getCountriesStateListReducer from './general/getCountriesStateList';
import getOrderByPoReducer from './general/getOrderByPo';
import postEasyPostShipmentReducer from './shipment/easyPost/postEasyPostShipment';
import postEasyPostBuyShipmentReducer from './shipment/easyPost/postEasyPostBuyShipment';
import postCoOrderReducer from './coilovers/orders/postCoOrder';
import postEasyShipShipmentReducer from './shipment/easyShip/postEasyShipShipment';
import postEasyShipBuyShipmentReducer from './shipment/easyShip/postEasyShipBuyShipment';
import postEasyShipRatesReducer from './shipment/easyShip/postEasyShipRates';
import getWarehouseDuplicatesReducer from './coilovers/warehouse/getWarehouseDuplicates';
import postAnnShipShipmentReducer from './shipment/annShip/postAnnShipShipment';
import postAnnShipBuyShipmentReducer from './shipment/annShip/postAnnShipBuyShipment';
import getPriorityCoOrdersReducer from './coilovers/orders/getPriorityCoOrders';
import getPrinterTasksReducer from './printerTasks/getPrinterTasks';
import patchPrinterTasksReducer from './printerTasks/patchPrinterTasks';
import getCoMissingPartsReducer from './coilovers/orders/getCoMissingParts';
import postCoMissingPartsReducer from './coilovers/orders/postCoMissingParts';
import postFedexPickupReducer from './fedex/pickup';
import userOnlineListReducer from './users/userOnlineList';
import updateListingCompatibilityListReducer from './compatibility/updateListingCompatibilityList';
import uploadFileReducer from './general/uploadFile';
import getEbayTasksReducer from './ebay/getEbayTasks';
import getEbayTaskResultFileReducer from './ebay/getEbayTaskResultFile';
import getJobsInProgressReducer from './jobs/getJobsInProgress';
import getJobsFailedReducer from './jobs/getJobsFailed';
import getFailedImportRowsReducer from './jobs/getFailedImportRows';
import getOrderInvoiceReducer from './coilovers/orders/getOrderInvoice';

const rootReducer = combineReducers({
  getNextIncrementValue: getNextIncrementValueReducer,
  application: applicationReducer,
  login: loginReducer,
  registration: registrationReducer,
  logout: logoutReducer,
  pathProfile: pathProfileReducer,
  getMyProfile: getMyProfileReducer,
  getRoles: getRolesReducer,
  getPermissions: getPermissionsReducer,
  postRoles: postRolesReducer,
  getRoleDetails: getRoleDetailsReducer,
  getUsers: getUsersReducer,
  getUserDetails: getUserDetailsReducer,
  patchUserRole: patchUserRoleReducer,
  deleteRoles: deleteRolesReducer,
  getLogs: getLogsReducer,
  logsFilter: logsFilterReducer,
  getOrderedParts: getOrderedPartsReducer,
  orderedPartsFilter: orderedPartsFilterReducer,
  patchOrderedParts: patchOrderedPartsReducer,
  deleteOrderedParts: deleteOrderedPartsReducer,
  getWarehouse: getWarehouseReducer,
  warehouseFilter: warehouseFilterReducer,
  postOrderedParts: postOrderedPartsReducer,
  patchWarehouse: patchWarehouseReducer,
  postWarehouse: postWarehouseReducer,
  deleteWarehouse: deleteWarehouseReducer,
  coOrdersFilter: coOrdersFilterReducer,
  getCoOrders: getCoOrdersReducer,
  deleteCoOrder: deleteCoOrderReducer,
  patchCoOrder: patchCoOrderReducer,
  actionCoOrder: actionCoOrderReducer,
  getArticles: getArticlesReducer,
  getArticlesDetails: getArticlesDetailsReducer,
  articlesFilter: articlesFilterReducer,
  patchArticles: patchArticlesReducer,
  getArticlesTheme: getArticlesThemeReducer,
  postArticlesTheme: postArticlesThemeReducer,
  getBrandList: getBrandListReducer,
  getCarMakeList: getCarMakeListReducer,
  getCarModelList: getCarModelListReducer,
  getCarYearList: getCarYearListReducer,
  getEbayCategoryList: getEbayCategoryListReducer,
  postArticles: postArticlesReducer,
  createPartTypeModal: createPartTypeModalReducer,
  getOrderedPartsList: getOrderedPartsListReducer,
  postOrderedPartsType: postOrderedPartsTypeReducer,
  getWarehouseExist: getWarehouseExistReducer,
  downloadFile: downloadFileReducer,
  getUploadsList: getUploadsListReducer,
  forgotPassword: forgotPasswordReducer,
  resetPassword: resetPasswordReducer,
  getListingCompatibilityList: getListingCompatibilityListReducer,
  updateListingCompatibilityList: updateListingCompatibilityListReducer,
  getCompatibilityModelGroup: getCompatibilityModelGroupReducer,
  getCompatibilityYearGroup: getCompatibilityYearGroupReducer,
  getCompatibilityCarsGroup: getCompatibilityCarsGroupReducer,
  vehicleCompatibilityList: vehicleCompatibilityListReducer,
  listingsFilter: listingsFilterReducer,
  getListings: getListingsReducer,
  getWarehouseMpnInfo: getWarehouseMpnInfoReducer,
  getAcceptanceToDay: getAcceptanceToDayReducer,
  getAcceptanceDelays: getAcceptanceDelaysReducer,
  getAcceptanceIssues: getAcceptanceIssuesReducer,
  postPrintZebraFile: postPrintZebraFileReducer,
  getOrderDoneByList: getOrderDoneByListReducer,
  getOrderStatistic: getOrderStatisticReducer,
  getCalculateReport: getCalculateReportReducer,
  createNewOrder: createNewOrderReducer,
  getCountriesList: getCountriesListReducer,
  getCountriesStateList: getCountriesStateListReducer,
  getOrderByPo: getOrderByPoReducer,
  postEasyPostShipment: postEasyPostShipmentReducer,
  postEasyPostBuyShipment: postEasyPostBuyShipmentReducer,
  postCoOrder: postCoOrderReducer,
  postEasyShipShipment: postEasyShipShipmentReducer,
  postEasyShipBuyShipment: postEasyShipBuyShipmentReducer,
  postEasyShipRates: postEasyShipRatesReducer,
  getWarehouseDuplicates: getWarehouseDuplicatesReducer,
  postAnnShipShipment: postAnnShipShipmentReducer,
  postAnnShipBuyShipment: postAnnShipBuyShipmentReducer,
  getPriorityCoOrders: getPriorityCoOrdersReducer,
  getPrinterTasks: getPrinterTasksReducer,
  patchPrinterTasks: patchPrinterTasksReducer,
  getCoMissingParts: getCoMissingPartsReducer,
  postCoMissingParts: postCoMissingPartsReducer,
  postFedexPickup: postFedexPickupReducer,
  userOnlineList: userOnlineListReducer,
  uploadFile: uploadFileReducer,
  getEbayTasks: getEbayTasksReducer,
  getEbayTaskResultFile: getEbayTaskResultFileReducer,
  getJobsInProgress: getJobsInProgressReducer,
  getJobsFailed: getJobsFailedReducer,
  getFailedImportRows: getFailedImportRowsReducer,
  getOrderInvoice: getOrderInvoiceReducer,
});

export default rootReducer;
